import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import Button from '../../../components/Button/Button';
import Icons from '../../../themes/icons';

export const EmptyCollab: React.FC<{ handleMarketChange?: () => void }> = ({
  handleMarketChange,
}) => {
  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      height={'calc(100vh - 320px)'}
    >
      <Box display={'flex'} flexDirection={'column'} alignItems={'center'} gap={'48px'}>
        <Icons.NoMemberIcon />
        <Stack spacing={4} alignItems={'center'}>
          <Box textAlign={'center'}>
            <Typography fontSize={'24px'} fontWeight={600} color={'#222'}>
              No member found…
            </Typography>
            <Typography fontSize={'15px'} fontWeight={500} color='#222'>
              Try changing your filters and search again.
            </Typography>
          </Box>
          <Button variant='outlined' sx={{ py: '10px', px: '24px' }} onClick={handleMarketChange}>
            Search all markets
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};
